
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/teradata-vantage",
      function () {
        return require("private-next-pages/sources/teradata-vantage.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/teradata-vantage"])
      });
    }
  